module.exports = __webpack_public_path__ + "img/web_nine_grids_2.b44310f9.jpg";